import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './styles/Redirect.css';

const particles = Array.from({ length: 30 });

const Redirect = () => {
  const REDIRECT_URL = "https://ojasrohatgi.com";
    // const REDIRECT_URL = "/";
  const COUNTDOWN_SECONDS = 5;

  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (countdown <= 0) {
      window.location.href = REDIRECT_URL;
      return;
    }
    const timer = setInterval(() => setCountdown(prev => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100 } },
  };

  const numberVariants = {
    hidden: { y: -50, opacity: 0, rotate: -20 },
    visible: {
      y: 0,
      opacity: 1,
      rotate: 0,
      transition: { type: 'spring', damping: 12, stiffness: 100 },
    },
    exit: {
      y: 50,
      opacity: 0,
      rotate: 20,
      transition: { duration: 0.3, ease: "easeOut" }
    }
  };

  return (
    <motion.div
      className="redirect-container"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      {/* Particles */}
      <div className="particles">
        {particles.map((_, i) => (
          <motion.div
            key={`particle-${i}`}
            className="particle"
            style={{
              width: Math.random() * 5 + 2,
              height: Math.random() * 5 + 2,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
            animate={{
              x: [0, Math.random() * 40 - 20, 0],
              y: [0, Math.random() * 40 - 20, 0],
            }}
            transition={{
              duration: Math.random() * 10 + 10,
              repeat: Infinity,
              repeatType: 'mirror',
              ease: 'easeInOut',
            }}
          />
        ))}
      </div>

      {/* Overlay */}
      <div className="overlay"></div>

      {/* Content */}
      <div className="content">
        <div className="number-container">
          <AnimatePresence mode="wait">
            <motion.h1
              key={countdown}
              className="number"
              variants={numberVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              {countdown}
            </motion.h1>
          </AnimatePresence>
        </div>

        <motion.p className="message" variants={itemVariants}>
          Redirecting to main website...
        </motion.p>

        <motion.button
          onClick={() => window.location.href = REDIRECT_URL}
          className="redirect-button"
          whileHover={{ scale: 1.05, y: -2, boxShadow: '0px 10px 20px rgba(0,0,0,0.2)' }}
          whileTap={{ scale: 0.95 }}
          variants={itemVariants}
        >
          Go Now →
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Redirect;
